import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/icons/x-circle.svg'


const _withScopeId = n => (_pushScopeId("data-v-b114a4ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 0,
  class: "uses"
}
const _hoisted_4 = ["value", "disabled"]
const _hoisted_5 = ["fill"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("polygon", { points: "13 2 3 14 12 14 11 22 21 10 12 10 13 2" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("polyline", { points: "12 7 7 2 2 7" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("polyline", { points: "12 14 7 9 2 14" }, null, -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass(["equipment-slot", { empty: _ctx.empty() }]),
      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.eventEmitter && _ctx.eventEmitter(...args))),
      disabled: _ctx.editMode
    }, [
      (_ctx.equipped[_ctx.index]?.uses > -1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.use($event))),
              class: "inline"
            }, [
              _createElementVNode("input", {
                value: _ctx.equipped[_ctx.index].uses,
                type: "number",
                disabled: !_ctx.editMode,
                class: _normalizeClass({ green: !_ctx.editMode && _ctx.equipped[_ctx.index].type !== _ctx.EquipmentTypes.AMMO && _ctx.equipped[_ctx.index].uses !== 0 }),
                onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.manualUsesChange && _ctx.manualUsesChange(...args))),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.use($event)))
              }, null, 42, _hoisted_4),
              (_openBlock(), _createElementBlock("svg", {
                class: _normalizeClass(["use-icon", _ctx.buttonClass()]),
                xmlns: "http://www.w3.org/2000/svg",
                width: "15",
                height: "15",
                viewBox: "0 0 24 24",
                fill: _ctx.boltFill(),
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.use($event)))
              }, _hoisted_7, 10, _hoisted_5))
            ]),
            (_ctx.equipped[_ctx.index]?.type === 'GUN')
              ? (_openBlock(), _createElementBlock("svg", {
                  key: 0,
                  class: _normalizeClass(["reload-icon", _ctx.buttonClass(true)]),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.reload($event))),
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "14",
                  height: "17",
                  viewBox: "0 0 14 17",
                  fill: "none",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, _hoisted_10, 2))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("span", {
        class: _normalizeClass([{ broken: _ctx.equipped[_ctx.index]?.broken }, "plain-text"])
      }, _toDisplayString(_ctx.equipped[_ctx.index]?.name || 'Empty'), 3)
    ], 10, _hoisted_2),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (!_ctx.editMode && !_ctx.empty())
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "drop button",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.drop($event))),
              src: _imports_0
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}